<div class="site-intelligence">
  <div class="info">
    Click the drop-pin (<app-svg-icon
      [iconName]="'location.svg'"
      [height]="'16px'"
      [width]="'16px'"
      [style.fill]="'#01695c'"
    ></app-svg-icon
    >) to select a location.
  </div>
  <div class="location">
    <span>Location</span>
    <div class="location-input">
      <div
        class="pin"
        [class.active]="isPinActive"
        (click)="activatePin()"
        tabindex="0"
        (keydown)="activatePin()"
      >
        <app-svg-icon
          [iconName]="'location.svg'"
          [height]="'20px'"
          [width]="'20px'"
          [style.fill]="'#01695c'"
        ></app-svg-icon>
      </div>
      <div>
        <input type="number" min="0" max="5280000" value="10" id="myRange" />
        <select>
          <option value="feet">Feet</option>
          <option value="kilometers">Kilometers</option>
          <option value="meters">Meters</option>
          <option value="miles">Miles</option>
        </select>
      </div>
    </div>
  </div>

  @if (markedPointAddress) {
    <div class="address">
      <span>Input Location</span>
      <p>{{ markedPointAddress }}</p>
    </div>
  }

  @if (locationDetails) {
    <div class="icons">
      <a
        href="javascript:void(0);"
        (click)="deleteMarkedPoint()"
        title="Delete"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
          <path
            d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"
          />
        </svg>
      </a>
      <a
        href="javascript:void(0);"
        (click)="exportToPDF()"
        title="Export to PDF"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path
            d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
          />
        </svg>
      </a>
      <a href="javascript:void(0);" (click)="refreshData()" title="Refresh">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path
            d="M463.5 224l8.5 0c13.3 0 24-10.7 24-24l0-128c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8l119.5 0z"
          />
        </svg>
      </a>
    </div>
    @if (!isLoading) {
      <div class="details">
        @for (detail of locationDetails; track $index) {
          <div class="card">
            <div
              class="card-header"
              (click)="toggleCard($index)"
              tabindex="0"
              (keydown)="toggleCard($index)"
            >
              <div class="title">{{ detail.layer_title }}</div>
              <div class="controls">
                <span class="count">{{ detail.features.length }}</span>
                <svg
                  [class.expanded]="expandedCards[$index]"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                >
                  <path d="M224 256L0 32h448L224 256z" />
                </svg>
              </div>
            </div>
            @if (expandedCards[$index]) {
              <div class="card-body">
                @for (feature of detail.features; track $index) {
                  <div class="feature-details">
                    <div class="content-wrapper">
                      @if (
                        detail.layer_title === "Regrid Nationwide Parcel Data"
                      ) {
                        <div class="distance-container">
                          <div class="id-distance">Approximate Distance</div>
                          <div>
                            {{ feature.attributes["Approximate_Distance"] }}
                          </div>
                        </div>
                        <div>
                          Regrid Nationwide Parcel Data:
                          <span class="bold-text">{{
                            feature.attributes["address"]
                          }}</span>
                        </div>
                        <div class="attribute-table">
                          @for (
                            field of getLayerFields(
                              "Regrid Nationwide Parcel Data"
                            );
                            track field.key
                          ) {
                            <div class="table-row">
                              <div class="table-cell">
                                {{ field.displayName }}
                              </div>
                              <div class="table-cell bold-text">
                                @if (field.key === "zoning_code_link") {
                                  <a
                                    [href]="feature.attributes[field.key]"
                                    target="_blank"
                                    >View</a
                                  >
                                } @else if (isDateField(field.key)) {
                                  {{
                                    feature.attributes[field.key]
                                      | date: "M/d/yyyy, h:mm a"
                                  }}
                                } @else {
                                  {{ feature.attributes[field.key] }}
                                }
                              </div>
                            </div>
                          }
                        </div>
                      } @else if (detail.layer_title === "USA Structures") {
                        <div class="distance-container">
                          <div class="id-distance">Approximate Distance</div>
                          <div>
                            {{ feature.attributes["Approximate_Distance"] }}
                          </div>
                        </div>
                        <div>
                          <p
                            style="
                              text-align: center;
                              font-size: 1rem;
                              font-weight: 500;
                              margin-bottom: 3px;
                            "
                          >
                            {{ feature.attributes["OCC_CLS"] }}
                          </p>
                          <p style="text-align: center; margin-top: 0px">
                            (Primary Occupany:
                            {{ feature.attributes["PRIM_OCC"] }})
                          </p>
                          <p>Address: {{ feature.attributes["PROP_ADDR"] }}</p>
                          <p>City: {{ feature.attributes["PROP_CITY"] }}</p>
                          <p>State: {{ feature.attributes["PROP_ST"] }}</p>
                          <p>Zip Code: {{ feature.attributes["PROP_ZIP"] }}</p>
                          <p>Height: {{ feature.attributes["HEIGHT"] }}</p>
                          <p>
                            Area: {{ feature.attributes["SQFEET"] }} sq. feet
                            ({{ feature.attributes["SQMETERS"] }} sq. meters)
                          </p>
                          <p>
                            Census Tract: {{ feature.attributes["CENSUSCODE"] }}
                          </p>
                          <p>
                            USNG Coordinates: {{ feature.attributes["USNG"] }}
                          </p>
                        </div>
                        <div class="attribute-table">
                          @for (
                            field of getLayerFields("USA Structures");
                            track field.key
                          ) {
                            <div class="table-row">
                              <div class="table-cell">
                                {{ field.displayName }}
                              </div>
                              <div class="table-cell bold-text">
                                @if (isDateField(field.key)) {
                                  {{
                                    feature.attributes[field.key]
                                      | date: "M/d/yyyy"
                                  }}
                                } @else {
                                  {{ feature.attributes[field.key] }}
                                }
                              </div>
                            </div>
                          }
                        </div>
                      } @else if (
                        detail.layer_title ===
                        "Environmental Health Hazard Index"
                      ) {
                        <div class="distance-container">
                          <div class="id-distance">
                            {{ feature.attributes["CATEGORY"] }}
                          </div>
                          <div>
                            {{ feature.attributes["Approximate_Distance"] }}
                          </div>
                        </div>
                        <div class="distance-container">
                          <div class="id-distance">
                            {{ feature.attributes["STATE_NAME"] }}
                          </div>
                        </div>
                        <div class="attribute-table">
                          @for (
                            field of getLayerFields(
                              "Environmental Health Hazard Index"
                            );
                            track field.key
                          ) {
                            <div class="table-row">
                              <div class="table-cell">
                                {{ field.displayName }}
                              </div>
                              <div class="table-cell bold-text">
                                @if (isDateField(field.key)) {
                                  {{
                                    feature.attributes[field.key]
                                      | date: "M/d/yyyy"
                                  }}
                                } @else {
                                  {{ feature.attributes[field.key] }}
                                }
                              </div>
                            </div>
                          }
                        </div>
                      } @else if (
                        detail.layer_title === "DSIRE Summary of Programs"
                      ) {
                        <div class="distance-container">
                          <div class="id-distance">
                            {{ feature.attributes["program_name"] }}
                          </div>
                          <div>
                            {{ feature.attributes["Approximate_Distance"] }}
                          </div>
                        </div>
                        <div class="attribute-table">
                          @for (
                            field of getLayerFields(
                              "DSIRE Summary of Programs"
                            );
                            track field.key
                          ) {
                            <div class="table-row">
                              <div class="table-cell">
                                {{ field.displayName }}
                              </div>
                              <div class="table-cell bold-text">
                                @if (isDateField(field.key)) {
                                  {{
                                    feature.attributes[field.key]
                                      | date: "M/d/yyyy"
                                  }}
                                } @else {
                                  {{ feature.attributes[field.key] }}
                                }
                              </div>
                            </div>
                          }
                        </div>
                      } @else if (
                        detail.layer_title ===
                        "ACS 5YR Demographic Estimate Data by Tract"
                      ) {
                        <div class="distance-container">
                          <div class="id-distance">
                            {{ feature.attributes["NAME"] }}
                          </div>
                          <div>
                            {{ feature.attributes["Approximate_Distance"] }}
                          </div>
                        </div>
                        <div class="attribute-table">
                          @for (
                            field of getLayerFields(
                              "ACS 5YR Demographic Estimate Data by Tract"
                            );
                            track field.key
                          ) {
                            <div class="table-row">
                              <div class="table-cell">
                                {{ field.displayName }}
                              </div>
                              <div class="table-cell bold-text">
                                @if (isDateField(field.key)) {
                                  {{
                                    feature.attributes[field.key]
                                      | date: "M/d/yyyy"
                                  }}
                                } @else {
                                  {{ feature.attributes[field.key] }}
                                }
                              </div>
                            </div>
                          }
                        </div>
                      } @else if (
                        detail.layer_title === "Difficult Development Areas"
                      ) {
                        <div class="distance-container">
                          <div class="id-distance">
                            {{ feature.attributes["DDA_TYPE"] }}
                          </div>
                          <div>
                            {{ feature.attributes["Approximate_Distance"] }}
                          </div>
                        </div>
                        <div class="attribute-table">
                          @for (
                            field of getLayerFields(
                              "Difficult Development Areas"
                            );
                            track field.key
                          ) {
                            <div class="table-row">
                              <div class="table-cell">
                                {{ field.displayName }}
                              </div>
                              <div class="table-cell bold-text">
                                @if (isDateField(field.key)) {
                                  {{
                                    feature.attributes[field.key]
                                      | date: "M/d/yyyy"
                                  }}
                                } @else {
                                  {{ feature.attributes[field.key] }}
                                }
                              </div>
                            </div>
                          }
                        </div>
                      } @else if (
                        detail.layer_title ===
                        "Low to Moderate Income Population by Block Group"
                      ) {
                        <div class="distance-container">
                          <div class="id-distance">
                            {{ feature.attributes["OBJECTID"] }}
                          </div>
                          <div>
                            {{ feature.attributes["Approximate_Distance"] }}
                          </div>
                        </div>
                        <div class="attribute-table">
                          @for (
                            field of getLayerFields(
                              "Low to Moderate Income Population by Block Group"
                            );
                            track field.key
                          ) {
                            <div class="table-row">
                              <div class="table-cell">
                                {{ field.displayName }}
                              </div>
                              <div class="table-cell bold-text">
                                @if (isDateField(field.key)) {
                                  {{
                                    feature.attributes[field.key]
                                      | date: "M/d/yyyy"
                                  }}
                                } @else {
                                  {{ feature.attributes[field.key] }}
                                }
                              </div>
                            </div>
                          }
                        </div>
                      } @else if (
                        detail.layer_title ===
                        "Low to Moderate Income Population by Tract"
                      ) {
                        <div class="distance-container">
                          <div class="id-distance">
                            {{ feature.attributes["LOWMODUNIV"] }}
                          </div>
                          <div>
                            {{ feature.attributes["Approximate_Distance"] }}
                          </div>
                        </div>
                        <div class="attribute-table">
                          @for (
                            field of getLayerFields(
                              "Low to Moderate Income Population by Tract"
                            );
                            track field.key
                          ) {
                            <div class="table-row">
                              <div class="table-cell">
                                {{ field.displayName }}
                              </div>
                              <div class="table-cell bold-text">
                                @if (isDateField(field.key)) {
                                  {{
                                    feature.attributes[field.key]
                                      | date: "M/d/yyyy"
                                  }}
                                } @else {
                                  {{ feature.attributes[field.key] }}
                                }
                              </div>
                            </div>
                          }
                        </div>
                      } @else if (
                        detail.layer_title ===
                        "Racially or Ethnically Concentrated Areas of Poverty (R/ECAPs)"
                      ) {
                        <div class="distance-container">
                          <div class="id-distance">
                            {{ feature.attributes["RCAP_90"] }}
                          </div>
                          <div>
                            {{ feature.attributes["Approximate_Distance"] }}
                          </div>
                        </div>
                        <div class="attribute-table">
                          @for (
                            field of getLayerFields(
                              "Racially or Ethnically Concentrated Areas of Poverty (R/ECAPs)"
                            );
                            track field.key
                          ) {
                            <div class="table-row">
                              <div class="table-cell">
                                {{ field.displayName }}
                              </div>
                              <div class="table-cell bold-text">
                                @if (isDateField(field.key)) {
                                  {{
                                    feature.attributes[field.key]
                                      | date: "M/d/yyyy"
                                  }}
                                } @else {
                                  {{ feature.attributes[field.key] }}
                                }
                              </div>
                            </div>
                          }
                        </div>
                      } @else if (
                        detail.layer_title ===
                        "Racially or Ethnically Concentrated Areas of Poverty (R/ECAPs)"
                      ) {
                        <div class="distance-container">
                          <div class="id-distance">
                            {{ feature.attributes["rcap_current"] }}
                          </div>
                          <div>
                            {{ feature.attributes["Approximate_Distance"] }}
                          </div>
                        </div>
                        <div class="attribute-table">
                          @for (
                            field of getLayerFields(
                              "Racially or Ethnically Concentrated Areas of Poverty (R/ECAPs)"
                            );
                            track field.key
                          ) {
                            <div class="table-row">
                              <div class="table-cell">
                                {{ field.displayName }}
                              </div>
                              <div class="table-cell bold-text">
                                @if (isDateField(field.key)) {
                                  {{
                                    feature.attributes[field.key]
                                      | date: "M/d/yyyy"
                                  }}
                                } @else {
                                  {{ feature.attributes[field.key] }}
                                }
                              </div>
                            </div>
                          }
                        </div>
                      } @else if (detail.layer_title === "Opportunity Zones") {
                        <div class="distance-container">
                          <div class="id-distance">Approximate Distance</div>
                          <div>
                            {{ feature.attributes["Approximate_Distance"] }}
                          </div>
                        </div>
                        <div class="attribute-table">
                          @for (
                            field of getLayerFields("Opportunity Zones");
                            track field.key
                          ) {
                            <div class="table-row">
                              <div class="table-cell">
                                {{ field.displayName }}
                              </div>
                              <div class="table-cell bold-text">
                                @if (isDateField(field.key)) {
                                  {{
                                    feature.attributes[field.key]
                                      | date: "M/d/yyyy"
                                  }}
                                } @else {
                                  {{ feature.attributes[field.key] }}
                                }
                              </div>
                            </div>
                          }
                        </div>
                      } @else if (
                        detail.layer_title === "CDFI Investment Areas"
                      ) {
                        <div class="distance-container">
                          <div class="id-distance">Approximate Distance</div>
                          <div>
                            {{ feature.attributes["Approximate_Distance"] }}
                          </div>
                        </div>
                        <div class="attribute-table">
                          @for (
                            field of getLayerFields("CDFI Investment Areas");
                            track field.key
                          ) {
                            <div class="table-row">
                              <div class="table-cell">
                                {{ field.displayName }}
                              </div>
                              <div class="table-cell bold-text">
                                @if (isDateField(field.key)) {
                                  {{
                                    feature.attributes[field.key]
                                      | date: "M/d/yyyy"
                                  }}
                                } @else {
                                  {{ feature.attributes[field.key] }}
                                }
                              </div>
                            </div>
                          }
                        </div>
                      } @else if (detail.layer_title === "USA Flood Hazards") {
                        <div class="distance-container">
                          <div class="id-distance">Approximate Distance</div>
                          <div>
                            {{ feature.attributes["Approximate_Distance"] }}
                          </div>
                        </div>
                        <div>
                          <p><b>USA Flood Hazard Areas December 2024</b></p>
                          <p>
                            <b>Map Symbol:</b>
                            {{ feature.attributes["esri_symbology"] }}
                          </p>
                          <p>
                            <b>Flood Zone:</b>
                            {{ feature.attributes["FLD_ZONE"] }}
                          </p>
                          <p>
                            <b>Zone Subtype:</b>
                            {{ feature.attributes["ZONE_SUBTY"] }}
                          </p>
                          <p>
                            <b>Flood Insurance Required? (T/F):</b>
                            {{
                              feature.attributes["SFHA_TF"] === "T"
                                ? "True"
                                : "False"
                            }}
                          </p>
                          <p><b>Publication Date:</b> December 18, 2024</p>
                        </div>
                      } @else if (
                        detail.layer_title === "New Market Tax Credit 2020"
                      ) {
                        <div class="distance-container">
                          <div class="id-distance">
                            {{
                              feature.attributes[
                                "Does_Census_Tract_Qualify_For_N"
                              ]
                            }}
                          </div>
                          <div>
                            {{ feature.attributes["Approximate_Distance"] }}
                          </div>
                        </div>
                        <div>
                          <p>
                            <b
                              >{{ feature.attributes["STATE_ABBR"] }} -
                              {{ feature.attributes["TRACT_FIPS"] }} -
                              {{
                                feature.attributes[
                                  "Does_Census_Tract_Qualify_For_N"
                                ] === "YES"
                                  ? "Eligible"
                                  : "Ineligible"
                              }}
                              - NMTC,
                              {{
                                feature.attributes[
                                  "Census_Tract_Percent_of_Benchma"
                                ] *
                                  100 <=
                                  60 ||
                                feature.attributes[
                                  "Census_Tract_Poverty_Rate____20"
                                ] >= 30
                                  ? "severe distress"
                                  : "distressed"
                              }}</b
                            >
                          </p>
                          <p>
                            <b
                              >Census 2020 Tract
                              {{
                                feature.attributes[
                                  "F2020_Census_Tract_Number_FIPS_"
                                ]
                              }}
                              assessment - Metropolitan
                            </b>
                          </p>
                          <p>
                            <b
                              >NMTC Status (2016-2020):
                              {{
                                feature.attributes[
                                  "Does_Census_Tract_Qualify_For_N"
                                ] === "YES"
                                  ? "Eligible"
                                  : "Ineligible"
                              }}
                              - NMTC,
                              {{
                                feature.attributes[
                                  "Census_Tract_Percent_of_Benchma"
                                ] *
                                  100 <=
                                  60 ||
                                feature.attributes[
                                  "Census_Tract_Poverty_Rate____20"
                                ] >= 30
                                  ? "severe distress"
                                  : "distressed"
                              }}</b
                            >
                          </p>
                          <p>
                            <b>People in poverty:</b>
                            {{
                              feature.attributes[
                                "Census_Tract_Poverty_Rate____20"
                              ] | number: "1.0-0"
                            }}%
                          </p>
                          <p>
                            <b>Median Family income:</b>
                            {{
                              feature.attributes[
                                "Census_Tract_Percent_of_Benchma"
                              ] * 100 | number: "1.0-0"
                            }}%
                          </p>
                          <p>
                            <b>Unemployment rate:</b>
                            {{
                              feature.attributes[
                                "Census_Tract_Unemployment_Rate_"
                              ] | number: "1.0-0"
                            }}%
                          </p>
                          <div>
                            <p><b>Distressed Census Tracts </b>have either:</p>
                            <ol>
                              <li>
                                a Median Family Income ≤ 80% of Area Median
                                Income (AMI) or
                              </li>
                              <li>a Poverty Rate of 20% or greater</li>
                            </ol>
                          </div>
                          <div>
                            <p>
                              <b>Severely Distressed Census Tracts </b>meet any
                              one of 3 criteria:
                            </p>
                            <ol>
                              <li>a Median Family Income ≤ 60% of AMI, or</li>
                              <li>a Poverty Rate ≥ 30%, or</li>
                              <li>
                                an Unemployment Rate ≥ 1.5 of the National
                                Unemployment Rate
                              </li>
                            </ol>
                          </div>
                          <div>
                            <p>
                              <a
                                href="https://www.cdfifund.gov/sites/cdfi/files/2022-11/CY_2022_NMTC_Program_Application.pdf"
                                target="_blank"
                                ><i
                                  >Download New Markets Tax Credit Application
                                  (English)</i
                                ></a
                              >
                            </p>
                            <p>
                              For more information, please click
                              <a
                                href="https://www.cdfifund.gov/programs-training/programs/new-markets-tax-credit"
                                target="_blank"
                                ><i>CDFI FUND</i></a
                              >.
                            </p>
                          </div>
                        </div>
                      } @else if (detail.layer_title === "EPA_IRA_LIDAC") {
                        <div class="distance-container">
                          <div class="id-distance">
                            {{ feature.attributes["cejst"] }}
                          </div>
                          <div>
                            {{ feature.attributes["Approximate_Distance"] }}
                          </div>
                        </div>
                        <div>
                          <p>
                            <b
                              >Census Block id :
                              {{ feature.attributes["id"] }}</b
                            >
                          </p>
                          <p>
                            The
                            <b>EPA IRA Disadvantaged Communities</b> combines
                            multiple datasets that individually can be used to
                            determine whether a community is disadvantaged for
                            the purposes of implementing programs under the IRA.
                          </p>
                          <p>
                            All data sets are assigned values at the Census
                            block group level.
                          </p>
                          <ul>
                            <li>
                              The criteria and associated datasets used in the
                              maps are:
                              <ul>
                                <li>
                                  Any census tract that is included as
                                  disadvantaged in the Climate and Economic
                                  Justice Screening Tool (CEJST)
                                </li>
                                <li>
                                  Any census block group at or above the 90th
                                  percentile for any of EJScreen’s Supplemental
                                  Indexes when compared to the nation or state
                                </li>
                                <li>
                                  Geographic areas within the Tribal lands
                                  category in EJScreen:
                                  <ul>
                                    <li>Alaska Native Allotments</li>
                                    <li>Alaska Native Villages</li>
                                    <li>American Indian Reservations</li>
                                    <li>
                                      American Indian Off-reservation Trust
                                      Lands
                                    </li>
                                    <li>Oklahoma Tribal Statistical Areas</li>
                                  </ul>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </div>
                      } @else if (
                        detail.layer_title ===
                        "Rural Designations: OMB NonMetropolitan Rural Areas"
                      ) {
                        <div class="distance-container">
                          <div class="id-distance">Approximate Distance</div>
                          <div>
                            {{ feature.attributes["Approximate_Distance"] }}
                          </div>
                        </div>
                        <div class="attribute-table">
                          @for (
                            field of getLayerFields(
                              "OMB NonMetropolitan Rural Areas"
                            );
                            track field.key
                          ) {
                            <div class="table-row">
                              <div class="table-cell">
                                {{ field.displayName }}
                              </div>
                              <div class="table-cell bold-text">
                                @if (isDateField(field.key)) {
                                  {{
                                    feature.attributes[field.key]
                                      | date: "M/d/yyyy"
                                  }}
                                } @else {
                                  {{ feature.attributes[field.key] }}
                                }
                              </div>
                            </div>
                          }
                        </div>
                      } @else if (
                        detail.layer_title ===
                        "Rural Designations: Priority Energy Communities Rural Areas"
                      ) {
                        <div class="distance-container">
                          <div class="id-distance">Approximate Distance</div>
                          <div>
                            {{ feature.attributes["Approximate_Distance"] }}
                          </div>
                        </div>
                        <div class="attribute-table">
                          @for (
                            field of getLayerFields(
                              "Priority Energy Communities Rural Areas"
                            );
                            track field.key
                          ) {
                            <div class="table-row">
                              <div class="table-cell">
                                {{ field.displayName }}
                              </div>
                              <div class="table-cell bold-text">
                                @if (isDateField(field.key)) {
                                  {{
                                    feature.attributes[field.key]
                                      | date: "M/d/yyyy"
                                  }}
                                } @else {
                                  {{ feature.attributes[field.key] }}
                                }
                              </div>
                            </div>
                          }
                        </div>
                      } @else if (
                        detail.layer_title ===
                        "Rural Designations: USDA RUCA Rural Areas"
                      ) {
                        <div class="distance-container">
                          <div class="id-distance">Approximate Distance</div>
                          <div>
                            {{ feature.attributes["Approximate_Distance"] }}
                          </div>
                        </div>
                        <div class="attribute-table">
                          @for (
                            field of getLayerFields("USDA RUCA Rural Areas");
                            track field.key
                          ) {
                            <div class="table-row">
                              <div class="table-cell">
                                {{ field.displayName }}
                              </div>
                              <div class="table-cell bold-text">
                                @if (isDateField(field.key)) {
                                  {{
                                    feature.attributes[field.key]
                                      | date: "M/d/yyyy"
                                  }}
                                } @else {
                                  {{ feature.attributes[field.key] }}
                                }
                              </div>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  }

  @if (isLoading) {
    <div class="loader">
      <span>Loading analysis results...</span>
    </div>
  } @else if (isLoading === false && !locationDetails) {
    <div class="loader">
      <span>No results found!</span>
    </div>
  }
</div>
